<!--
 * @Description: 账号开户
 * @Date: 2020-11-03 09:41:19
-->
<template>
  <div>
    <h3 class="kaihu">账号开户</h3>
    <step :active="0"></step>
    <p class="notes" style="padding-left:124px;">
      请上传的证件的彩色扫描件或照片，并确保您上传的图片信息内容清晰、可辨，单个文件大小不超过2M。
    </p>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="230px"
      class="ruleForm"
    >
      <template v-if="selectBankName === 'fyBank'">
        <div class="colorBlock">请选择开户银行：</div>
        <el-form-item>
          <span slot="label" class="elLabel"></span>
          <el-radio-group v-model="ruleForm.fyChannel">
            <el-radio :label="'01'">中信百信银行</el-radio>
            <el-radio :label="'10'">福建华通银行</el-radio>
            <el-radio :label="'12'">江苏苏商银行</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
      <div v-if="selectBankName === 'fyBank'" class="banktips">
        <img
          style="width: 20px; height: 20px; cursor: pointer"
          :src="require('@/assets/shenhe.svg')"
          alt=""
        />
        预计开户时间：{{ tipsDay }}个工作日，实际以银行审核结果为准
      </div>
      <div class="colorBlock">公司信息：</div>
      <el-form-item>
        <span slot="label" class="elLabel">公司名称：</span>
        {{ user.userName }}
      </el-form-item>
      <div class="flexBox">
        <el-form-item label="公司电话：" prop="companyPhone" class="leftLabel">
          <span slot="label" class="elLabel">公司电话：</span>
          <el-input
            v-model="ruleForm.companyPhone"
            placeholder="请输入公司电话"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="企业主体类型："
          prop="companyMainType"
          class="rightLabel"
        >
          <span slot="label" class="elLabel">企业主体类型：</span>
          <el-select
            v-model="ruleForm.companyMainType"
            placeholder="请选择企业主体类型"
          >
            <el-option
              v-for="item in companyType"
              :key="item.key"
              :label="item.label"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="flexBox">
        <div class="leftLabel">
          <el-form-item label="公司证件号码：" prop="companyCardType">
            <span slot="label" class="elLabel">公司证件号码：</span>
            <el-select
              v-model="ruleForm.companyCardType"
              placeholder="请选择证件类型"
            >
              <el-option
                v-for="item in cardType"
                :key="item.key"
                :label="item.label"
                :value="item.key"
              ></el-option>
            </el-select>
            <el-input
              v-model="ruleForm.companyCardNo"
              placeholder="请输入对应证件码"
            ></el-input>
          </el-form-item>
          <el-form-item label="开户证件信息：" prop="openAccountType">
            <span slot="label" class="elLabel">开户证件信息：</span>
            <el-select
              v-model="ruleForm.openAccountType"
              placeholder="请选择证件类型"
            >
              <el-option
                v-for="item in kaihuType"
                :key="item.key"
                :label="item.label"
                :value="item.key"
              ></el-option>
            </el-select>
            <el-input
              v-model="ruleForm.openAccountCode"
              placeholder="请输入对应证件码"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="注册地址："
            prop="companyBusinessAddress"
            class="leftLabel"
          >
            <span slot="label" class="elLabel">注册地址：</span>
            <el-input
              v-model="ruleForm.companyBusinessAddress"
              placeholder="请输入营业执照的注册地址"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="isOtherBank"
            label="行业类别："
            prop="category"
            class="leftLabel"
          >
            <span slot="label" class="elLabel">行业类别：</span>
            <el-cascader
              ref="cascaderRefByCategory"
              v-model="ruleForm.category"
              placeholder="请选择"
              :options="categoryListOption"
              clearable
              filterable
            ></el-cascader>
          </el-form-item>
          <el-form-item
            v-if="isOtherBank"
            label="注册地所属省市区："
            prop="ssq"
            class="leftLabel"
          >
            <span slot="label" class="elLabel">注册地所属省市区：</span>
            <el-cascader
              ref="cascaderRefByArea"
              :value="ruleForm.ssq"
              @change="ssqChange"
              placeholder="请选择"
              :props="ssqProps"
              filterable
              clearable
            ></el-cascader>
          </el-form-item>
        </div>
        <div class="rightLabel">
          <el-form-item label="营业执照副本：" prop="companyBusinessLicense">
            <span slot="label" class="elLabel">
              营业执照副本：
              <br />
              <i class="redHint">
                请上传驸有公章
                <br />
                的营业执照副本
              </i>
            </span>
            <UploadImgOne
              :initUrl="ruleForm.companyBusinessLicense"
              @upload-done="coverPicDone"
              :noNeedDefaultImg="true"
              placeWord="营业执照副本"
            ></UploadImgOne>
          </el-form-item>
          <step1Dt
            :value="ruleForm"
            label="营业执照"
            keyName="companyBusiness"
            :startLabel="'营业执照有效期起始日'"
            :endLabel="'营业执照有效期终止日'"
          />
          <el-form-item
            v-if="isOtherBank"
            label="注册资本："
            prop="registeredCapital"
          >
            <span slot="label" class="elLabel">注册资本：</span>
            <el-input
              v-model="ruleForm.registeredCapital"
              oninput="this.value = this.value.replace(/[^\d.]/g, '')"
              placeholder="请输入注册资本（单位：万元）"
            ></el-input>
            <span>单位（万元）</span>
          </el-form-item>
        </div>
      </div>
      <el-form-item v-if="isOtherBank" label="经营范围" prop="businessScope">
        <span slot="label" class="elLabel">经营范围：</span>
        <el-input
          style="width: 75.2%;"
          type="textarea"
          :rows="4"
          v-model="ruleForm.businessScope"
          placeholder="请输入经营范围"
          maxlength="1024"
        ></el-input>
      </el-form-item>
      <div class="colorBlock">法人信息：</div>
      <div class="flexBox">
        <el-form-item
          label="法人姓名："
          prop="legalPersonName"
          class="leftLabel"
        >
          <span slot="label" class="elLabel">法人姓名：</span>
          <el-input
            v-model="ruleForm.legalPersonName"
            placeholder="请输入法人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="法人身份证号："
          prop="legalPersonCardCode"
          class="rightLabel"
        >
          <span slot="label" class="elLabel">法人身份证号：</span>
          <el-input
            v-model="ruleForm.legalPersonCardCode"
            placeholder="请输入法人身份证号"
          ></el-input>
        </el-form-item>
      </div>
      <div class="flexBox" style="align-items:center">
        <el-form-item
          label="法人身份证正反面："
          style="display:flex;"
          class="flexItem leftLabel"
          prop="legalPersonCardZheng"
        >
          <span slot="label" class="elLabel">
            法人身份证正反面：
            <br />
            <i class="redHint" style="width:126px;">企业用户需加盖公章</i>
          </span>
          <UploadImgOne
            :initUrl="ruleForm.legalPersonCardZheng"
            @upload-done="coverPicDone2"
            placeWord="个人信息页"
            :noNeedDefaultImg="true"
          ></UploadImgOne>
          <UploadImgOne
            :initUrl="ruleForm.legalPersonCardFan"
            @upload-done="coverPicDone3"
            placeWord="国徽页"
            :noNeedDefaultImg="true"
          ></UploadImgOne>
        </el-form-item>
        <step1Dt
          :value="ruleForm"
          :startLabel="'身份证有效期起始日'"
          :endLabel="'身份证有效期终止日'"
          keyName="legalPersonCard"
        />
      </div>
      <div
        v-if="selectBankName === 'fyBank'"
        class="flexBox"
        style="align-items:center"
      >
        <el-form-item label="法人手机号：" prop="legalPhone" class="rightLabel">
          <span slot="label" class="elLabel">法人手机号：</span>
          <el-input
            v-model="ruleForm.legalPhone"
            placeholder="请输入法人手机号"
          ></el-input>
        </el-form-item>
      </div>
      <div class="colorBlock">银行信息：</div>
      <div class="flexBox">
        <el-form-item label="开户银行：" prop="openBankName" class="leftLabel">
          <span slot="label" class="elLabel">开户银行：</span>
          <dic-select
            @dic-select-obj="saveProId"
            :fuzzyDef="searchBank"
            :prop="ProProp"
            :ajaxQueryObj="{
              payPassagewayCode: selectBankName
            }"
            ajaxQuery="name"
            :defaultActive="defaultBank"
            placeholder="请选择开户银行"
          ></dic-select>
        </el-form-item>
        <el-form-item label="开户名：" prop="openName" class="rightLabel">
          <span slot="label" class="elLabel">开户名：</span>
          <el-input
            v-model="ruleForm.openName"
            placeholder="请输入开户名"
          ></el-input>
        </el-form-item>
      </div>
      <div class="flexBox">
        <el-form-item
          label="银行账号："
          prop="openBankNumber"
          class="leftLabel"
        >
          <span slot="label" class="elLabel">银行账号：</span>
          <el-input
            v-model="ruleForm.openBankNumber"
            placeholder="请输入银行账号"
          ></el-input>
        </el-form-item>
      </div>

      <div class="colorBlock">经办人信息：</div>
      <div class="flexBox">
        <el-form-item
          label="经办人姓名："
          prop="transactorName"
          class="leftLabel"
        >
          <span slot="label" class="elLabel">经办人姓名：</span>
          <el-input
            v-model="ruleForm.transactorName"
            placeholder="请输入经办人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="transactorCardCode" class="rightLabel">
          <span slot="label" class="elLabel">经办人身份证号：</span>
          <el-input
            v-model="ruleForm.transactorCardCode"
            placeholder="请输入经办人身份证号"
          ></el-input>
        </el-form-item>
      </div>
      <div class="flexBox">
        <div class="leftLabel">
          <el-form-item label="经办人手机号：" prop="transactorPhone">
            <span slot="label" class="elLabel">经办人手机号：</span>
            <el-input
              v-model="ruleForm.transactorPhone"
              placeholder="请输入经办人手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="经办人邮箱：" prop="transactorEmail">
            <span slot="label" class="elLabel">经办人邮箱：</span>
            <el-input
              v-model.trim="ruleForm.transactorEmail"
              placeholder="请输入经办人邮箱"
            ></el-input>
          </el-form-item>
        </div>
        <step1Dt
          :value="ruleForm"
          :startLabel="'身份证有效期起始日'"
          :endLabel="'身份证有效期终止日'"
          keyName="transactorCard"
        />
      </div>
      <el-form-item
        label="经办人身份证正反面："
        style="display:flex;"
        class="flexItem leftLabel"
        prop="transactorCardZheng"
      >
        <span slot="label" class="elLabel">
          经办人身份证正反面：
          <br />
          <i class="redHint" style="width:126px;">企业用户需加盖公章</i>
        </span>
        <UploadImgOne
          :initUrl="ruleForm.transactorCardZheng"
          @upload-done="coverPicDone4"
          placeWord="个人信息页"
          :noNeedDefaultImg="true"
        ></UploadImgOne>
        <UploadImgOne
          :initUrl="ruleForm.transactorCardFan"
          @upload-done="coverPicDone5"
          placeWord="国徽页"
          :noNeedDefaultImg="true"
        ></UploadImgOne>
      </el-form-item>
      <template v-if="isOtherBank">
        <div style="align-items: center;" class="colorBlock">
          受益人信息
          <el-tooltip
            class="item"
            effect="dark"
            content="指对企业的股权、表决权等权益拥有超过一定比例（通常是 25%）的自然人，能够通过人事、财务等方式对企业的运营进行控制的人"
            placement="top-start"
          >
            <img
              style="width: 20px; height: 20px; cursor: pointer;margin: 40px 10px;"
              :src="require('@/assets/xinxi.svg')"
              alt=""
            />
          </el-tooltip>
          ：
          <el-button @click="addFyBeneficiaryInfo" type="warning">
            添加受益人信息
          </el-button>
          <span style="font-size: 15px; font-weight: 500;">
            （请填写实际收益比例超过25%的受益人）
          </span>
        </div>
        <div
          v-for="(item, index) in ruleForm.fyBeneficiaryInfoList"
          :key="index + 'fyBeneficiaryInfo'"
        >
          <div
            v-if="index"
            style="background: #f2e9e9;width: 98%;height: 1px;margin: 20px;position: relative;"
          >
            <el-button
              class="del__btn"
              type="danger"
              icon="el-icon-delete"
              @click="delItem(ruleForm.fyBeneficiaryInfoList, index)"
            ></el-button>
          </div>
          <div class="flexBox">
            <el-form-item
              label="受益人姓名："
              :prop="'fyBeneficiaryInfoList.' + index + '.name'"
              class="leftLabel"
              :rules="[
                { required: true, message: '请输入受益人姓名', trigger: 'blur' }
              ]"
            >
              <span slot="label" class="elLabel">受益人姓名：</span>
              <el-input
                v-model="item.name"
                placeholder="请输入受益人姓名"
                maxlength="100"
              ></el-input>
            </el-form-item>
            <el-form-item
              label=""
              :prop="'fyBeneficiaryInfoList.' + index + '.certTp'"
              class="rightLabel"
              :rules="[
                {
                  required: true,
                  message: '请选择受益人证件类型',
                  trigger: 'change'
                }
              ]"
            >
              <span slot="label" class="elLabel">受益人证件类型：</span>
              <el-select
                v-model="item.certTp"
                clearable
                placeholder="请选择证件类型"
                @change="
                  () => {
                    imgTypeChange(item, 'fyBeneficiary.' + index + '.Ref');
                  }
                "
              >
                <el-option label="身份证" value="0"></el-option>
                <el-option label="外国护照" value="1"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="flexBox">
            <el-form-item
              label="受益人手机号："
              class="leftLabel"
              :prop="'fyBeneficiaryInfoList.' + index + '.mobile'"
              :rules="[
                {
                  required: true,
                  message: '请输入受益人手机号',
                  trigger: 'blur'
                }
              ]"
            >
              <span slot="label" class="elLabel">受益人手机号：</span>
              <el-input
                maxlength="100"
                v-model="item.mobile"
                oninput="value=value.replace(/[^\d]/g,'')"
                placeholder="请输入受益人手机号"
              ></el-input>
            </el-form-item>
            <el-form-item
              label=""
              prop="certNo"
              class="rightLabel"
              :prop="'fyBeneficiaryInfoList.' + index + '.certNo'"
              :rules="[
                {
                  required: true,
                  message: '请输入受益人证件号',
                  trigger: 'blur'
                }
              ]"
            >
              <span slot="label" class="elLabel">受益人证件号：</span>
              <el-input
                v-model="item.certNo"
                placeholder="请输入受益人证件号"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </div>
          <div class="flexBox" style="align-items: flex-start">
            <el-form-item
              label="受益人证件正反面："
              style="display:flex;"
              class="flexItem"
              :prop="'fyBeneficiaryInfoList.' + index + '.cardImg'"
              :rules="validatorCardImg(index)"
            >
              <span slot="label" class="elLabel">
                受益人证件正反面：
                <br />
              </span>
              <UploadImgOne
                :ref="'fyBeneficiary.' + index + '.Ref'"
                :initUrl="item.portraitFilePath"
                @upload-done="
                  e => {
                    coverPicDoneByArray(
                      e,
                      item,
                      'portraitFilePath',
                      'fyBeneficiaryInfoList.' + index + '.cardImg'
                    );
                  }
                "
                placeWord="受益人证件正面"
                :noNeedDefaultImg="true"
              ></UploadImgOne>
              <UploadImgOne
                :ref="'fyBeneficiary.' + index + '.Ref'"
                :initUrl="item.badgeFilePath"
                @upload-done="
                  e => {
                    coverPicDoneByArray(
                      e,
                      item,
                      'badgeFilePath',
                      'fyBeneficiaryInfoList.' + index + '.cardImg'
                    );
                  }
                "
                placeWord="受益人证件反面"
                :noNeedDefaultImg="true"
              ></UploadImgOne>
            </el-form-item>
            <step1Dt
              :value="item"
              startDtKeyName="validDateStart"
              endDtKeyName="validDateEnd"
              :startLabel="'受益人证件有效期起始日'"
              :endLabel="'受益人证件有效期到期日'"
              :rulesStartName="
                'fyBeneficiaryInfoList.' + index + '.validDateStart'
              "
              :rulesEndName="'fyBeneficiaryInfoList.' + index + '.validDateEnd'"
            />
          </div>
          <div class="flexBox">
            <el-form-item
              label="受益人地址："
              class="leftLabel"
              :prop="'fyBeneficiaryInfoList.' + index + '.address'"
              :rules="[
                {
                  required: true,
                  message: '请输入受益人地址',
                  trigger: 'blur'
                }
              ]"
            >
              <span slot="label" class="elLabel">受益人地址：</span>
              <el-input
                maxlength="100"
                v-model="item.address"
                placeholder="请输入受益人地址"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="受益方式："
              class="rightLabel"
              :prop="'fyBeneficiaryInfoList.' + index + '.beneficiaryType'"
              :rules="[
                {
                  required: true,
                  message: '请选择受益方式',
                  trigger: 'change'
                }
              ]"
            >
              <span slot="label" class="elLabel">受益方式：</span>
              <el-select
                v-model="item.beneficiaryType"
                clearable
                placeholder="请选择受益方式"
              >
                <el-option label="股权" value="01"></el-option>
                <el-option label="表决权" value="02"></el-option>
                <el-option label="高级管理人员" value="03"></el-option>
                <el-option label="其他" value="04"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
      </template>
      <template v-if="isOtherBank">
        <div style="align-items: center;" class="colorBlock">
          股东信息：
          <el-button @click="addFyShareholderInfo" type="warning">
            添加股东信息
          </el-button>
          <span style="font-size: 15px; font-weight: 500;">
            （最少填写1组，最多填写4组股东信息）
          </span>
        </div>
        <div
          v-for="(item, index) in this.ruleForm.fyShareholderInfoList"
          :key="index + 'fyShareholderInfo'"
        >
          <div
            v-if="index"
            style="background: #f2e9e9;width: 98%;height: 1px;margin: 20px;position: relative;"
          >
            <el-button
              class="del__btn"
              type="danger"
              icon="el-icon-delete"
              @click="delItem(ruleForm.fyShareholderInfoList, index)"
            ></el-button>
          </div>
          <div class="flexBox">
            <el-form-item
              label="实控人/股东名称："
              class="leftLabel"
              :prop="'fyShareholderInfoList.' + index + '.name'"
              :rules="[
                {
                  required: true,
                  message: '请输入实控人/股东名称',
                  trigger: 'blur'
                }
              ]"
            >
              <span slot="label" class="elLabel">实控人/股东名称：</span>
              <el-input
                maxlength="100"
                v-model="item.name"
                placeholder="请输入实控人/股东名称"
              ></el-input>
            </el-form-item>
            <el-form-item
              label=""
              :prop="'fyShareholderInfoList.' + index + '.certTp'"
              :rules="[
                {
                  required: true,
                  message: '请选择实控人/股东证件类型',
                  trigger: 'change'
                }
              ]"
              class="rightLabel"
            >
              <span slot="label" class="elLabel">实控人/股东证件类型：</span>
              <el-select
                v-model="item.certTp"
                clearable
                placeholder="请选择实控人/股东证件类型"
                @change="
                  () => {
                    imgTypeChange(item, 'fyShareholder.' + index + '.Ref');
                  }
                "
              >
                <el-option label="身份证" value="0"></el-option>
                <el-option label="营业执照" value="1"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="flexBox" style="align-items: flex-start">
            <el-form-item
              label="实控人/股东证件号："
              class="leftLabel"
              :prop="'fyShareholderInfoList.' + index + '.certNo'"
              :rules="[
                {
                  required: true,
                  message: '请输入实控人/股东证件号',
                  trigger: 'blur'
                }
              ]"
            >
              <span slot="label" class="elLabel">实控人/股东证件号：</span>
              <el-input
                maxlength="30"
                v-model="item.certNo"
                :placeholder="
                  +item.certTp === 0
                    ? '请输入身份证号'
                    : '请输入统一社会信用代码'
                "
              ></el-input>
            </el-form-item>
          </div>
          <div class="flexBox" style="align-items: flex-start">
            <el-form-item
              v-if="+item.certTp === 0"
              label="实控人/股东证件正反面："
              style="display:flex;"
              class="flexItem"
              :prop="'fyShareholderInfoList.' + index + '.cardImg'"
              :rules="validatorCardImg2(index)"
            >
              <span slot="label" class="elLabel">
                实控人/股东证件正反面：
                <br />
              </span>
              <UploadImgOne
                :ref="'fyShareholder.' + index + '.Ref'"
                :initUrl="item.portraitFilePath"
                @upload-done="
                  e => {
                    coverPicDoneByArray(
                      e,
                      item,
                      'portraitFilePath',
                      'fyShareholderInfoList.' + index + '.cardImg'
                    );
                  }
                "
                placeWord="实控人/股东证件正面"
                :noNeedDefaultImg="true"
              ></UploadImgOne>
              <UploadImgOne
                :ref="'fyShareholder.' + index + '.Ref'"
                :initUrl="item.badgeFilePath"
                @upload-done="
                  e => {
                    coverPicDoneByArray(
                      e,
                      item,
                      'badgeFilePath',
                      'fyShareholderInfoList.' + index + '.cardImg'
                    );
                  }
                "
                placeWord="实控人/股东证件反面"
                :noNeedDefaultImg="true"
              ></UploadImgOne>
            </el-form-item>
            <el-form-item
              v-else
              label="营业执照："
              style="display:flex;"
              class="flexItem"
              :prop="'fyShareholderInfoList.' + index + '.cardImg'"
              :rules="validatorCardImg3(index)"
            >
              <span slot="label" class="elLabel">
                营业执照：
                <br />
              </span>
              <UploadImgOne
                :ref="'fyShareholder.' + index + '.Ref'"
                :initUrl="item.portraitFilePath"
                @upload-done="
                  e => {
                    coverPicDoneByArray(
                      e,
                      item,
                      'portraitFilePath',
                      'fyShareholderInfoList.' + index + '.cardImg'
                    );
                  }
                "
                placeWord="营业执照证件"
                :noNeedDefaultImg="true"
              ></UploadImgOne>
            </el-form-item>
            <step1Dt
              :value="item"
              startDtKeyName="validDateStart"
              endDtKeyName="validDateEnd"
              :startLabel="'实控人/股东证件有效期起始日'"
              :endLabel="'实控人/股东证件有效期到期日'"
              :rulesStartName="
                'fyShareholderInfoList.' + index + '.validDateStart'
              "
              :rulesEndName="'fyShareholderInfoList.' + index + '.validDateEnd'"
            />
          </div>
        </div>
      </template>
      <el-form-item>
        <el-checkbox v-model="checked" style="width:100%;text-align:center;">
          我同意遵守
          <a
            v-if="selectBankName === 'zbBank'"
            href="//cdn.yxvzb.com/WEB/SaaS/agreement/武汉众邦银行E账通系统开户三方协议-企业（V1.0版本）.docx"
          >
            《武汉众邦银行E账通系统开户三方协议》
          </a>
          <a
            v-else-if="selectBankName === 'fyBank'"
            href="//cdn.yxvzb.com/WEB/SaaS/agreement/富友-向日葵平台专用账户协议.docx"
          >
            《富友支付开户三方协议》
          </a>
        </el-checkbox>
      </el-form-item>
      <el-form-item>
        <div style="text-align:center">
          <!-- 只有线下可以返回 -->
          <el-button
            v-if="offlineProject === 2"
            @click="$emit('changeComp', { type: 0, currentCom: 'dashBoard' })"
          >
            返回
          </el-button>
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
            :loading="btLoading"
            :disabled="!checked"
          >
            提交
          </el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { dictionaries } from '@/api/ajax';
import dicSelect from '@/components/Common/dicSelect.vue';
import step from './step.vue';
import UploadImgOne from '@/components/Common/newUpLoadImgOne.vue';
import { getStorage } from '@/tools/storage';
import { btLoading } from '@/Mixin/btLoading';
import step1ZbMixin from '../mixins/setp1-zb-mixin';
import step1Dt from './step1-dt.vue';
export default {
  mixins: [btLoading, step1ZbMixin],
  props: {
    selectBankName: String,
    authStatus: Object
  },
  data() {
    const checkOpenBankCityCode = (rule, value, callback) => {
      if (!this.ruleForm.openBankCityCode) {
        callback(new Error('请选择开户行所在地'));
      } else {
        callback();
      }
    };
    const checkLegalPersonCardZheng = (rule, value, callback) => {
      if (
        !this.ruleForm.legalPersonCardZheng ||
        !this.ruleForm.legalPersonCardFan
      ) {
        callback(new Error('请上传法人身份证'));
      } else {
        callback();
      }
    };
    const checkTransactorCardZheng = (rule, value, callback) => {
      if (
        !this.ruleForm.transactorCardZheng ||
        !this.ruleForm.transactorCardFan
      ) {
        callback(new Error('请上传经办人身份证'));
      } else {
        callback();
      }
    };
    const checkOpenBankName = (rule, value, callback) => {
      if (!this.ruleForm.openBankName) {
        callback(new Error('请选择开户银行'));
      } else {
        callback();
      }
    };
    const checkCompanyBusinessLicense = (rule, value, callback) => {
      if (!this.ruleForm.companyBusinessLicense) {
        callback(new Error('请上传营业执照'));
      } else {
        callback();
      }
    };
    const checkOpenAccountType = (rule, value, callback) => {
      if (!this.ruleForm.openAccountType || !this.ruleForm.openAccountCode) {
        callback(new Error('请选择开户证件类型并填写证件号'));
      } else {
        callback();
      }
    };
    return {
      user: getStorage('user'),
      categoryListOption: [], //行业类别下拉
      ruleForm: {
        phone: '',
        type: 1,
        zhizhaoCopy: '',
        openBankProvinceCode: '',
        companyBusinessLicense: '', //todo：图片上传本机无法上传所以写死 记得修改
        legalPhone: '',
        legalPersonCardZheng: '',
        legalPersonCardFan: '',

        transactorCardZheng: '',
        transactorCardFan: '',
        fyChannel: '01',
        category: '',
        ssq: [],
        registeredCapital: '',
        businessScope: '',
        // 受益人信息
        fyBeneficiaryInfoList: [
          {
            name: '',
            certTp: '0',
            certNo: '',
            validDateStart: '',
            validDateEnd: '',
            mobile: '',
            address: '',
            portraitFilePath: '',
            badgeFilePath: '',
            beneficiaryType: ''
          }
        ],
        // 股东/实控人信息
        fyShareholderInfoList: [
          {
            name: '',
            certTp: '0',
            certNo: '',
            validDateStart: '',
            validDateEnd: '',
            portraitFilePath: '',
            badgeFilePath: ''
          }
        ]
      },
      checked: false,
      offlineProject: 0,
      companyType: [
        { label: ' 商业公司', key: 1 }
        // { label: '个体工商户', key: 2 }
      ],
      cardType: [
        // { label: '个体工商户', key: 0 },
        // { label: '三证三号', key: 1 },
        { label: '三证合一', key: 2 }
      ],
      kaihuType: [
        { label: '开户许可证核准号', key: 1 },
        { label: '基本存款账户编号', key: 2 }
      ],
      rules: {
        category: [
          {
            required: true,
            message: '请选择行业类别',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请选择行业类别'));
              } else if (value.length <= 0 || !value[0]) {
                callback(new Error('请选择行业类别'));
              } else {
                callback();
              }
            }
          }
        ],
        ssq: [
          {
            required: true,
            message: '请选择注册地所属省市区',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请选择注册地所属省市区'));
              } else if (value.length <= 0 || !value[0]) {
                callback(new Error('请选择注册地所属省市区'));
              } else {
                callback();
              }
            }
          }
        ],
        registeredCapital: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入注册资金'));
              } else if (+value > 9999999999) {
                callback(new Error('输入的数值超过上限，请重新输入'));
              } else if (+value === 0) {
                callback(new Error('请输入正确的数值'));
              } else if (/\.\d*\./.test(value)) {
                callback(new Error('请输入正确的数值'));
              } else if (
                String(value).includes('.') &&
                String(value).split('.')[1].length > 4
              ) {
                callback(new Error('最多输入四位小数'));
              } else {
                callback();
              }
            }
          }
        ],
        businessScope: [
          {
            required: true,
            message: '请输入经营范围',
            trigger: 'blur'
          }
        ],
        companyPhone: [
          {
            required: true,
            message: '请输入公司电话',
            trigger: 'change'
          }
        ],
        companyMainType: [
          {
            required: true,
            message: '请选择企业主体类型',
            trigger: 'change'
          }
        ],
        companyCardType: [
          {
            required: true,
            message: '请选择公司证件编码类型',
            trigger: 'change'
          }
        ],
        companyCardNo: [
          {
            required: true,
            message: '请输入公司证件编码',
            trigger: 'change'
          }
        ],
        companyBusinessLicense: [
          {
            required: true,
            validator: checkCompanyBusinessLicense,
            trigger: 'change'
          }
        ],
        openAccountType: [
          {
            required: true,
            validator: checkOpenAccountType,
            trigger: 'change'
          }
        ],
        openAccountCode: [
          {
            required: true,
            message: '请输入开户证件编码',
            trigger: 'change'
          }
        ],
        legalPersonName: [
          {
            required: true,
            message: '请输入法人姓名',
            trigger: 'change'
          }
        ],
        legalPersonCardZheng: [
          {
            required: true,
            validator: checkLegalPersonCardZheng,
            trigger: 'change'
          }
        ],
        legalPersonCardCode: [
          {
            required: true,
            message: '请输入法人身份证号',
            trigger: 'change'
          }
        ],
        legalPhone: [
          {
            required: true,
            message: '请输入法人手机号',
            trigger: 'change'
          }
        ],
        legalPersonCardFan: [
          {
            required: true,
            message: '请上传法人身份证反面',
            trigger: 'change'
          }
        ],
        openBankName: [
          {
            required: true,
            validator: checkOpenBankName,
            trigger: 'blur'
          }
        ],
        openName: [
          {
            required: true,
            message: '请输入开户名',
            trigger: 'change'
          }
        ],
        openBankNumber: [
          {
            required: true,
            message: '请输入银行账号',
            trigger: 'change'
          }
        ],
        openBankCityCode: [
          {
            required: true,
            trigger: 'blur',
            validator: checkOpenBankCityCode
          }
        ],
        openBankAddress: [
          {
            required: true,
            message: '请输入银行支行全称', // todojml
            trigger: 'change'
          }
        ],
        transactorCardCode: [
          {
            required: true,
            message: '请输入经办人身份证号',
            trigger: 'change'
          }
        ],
        transactorPhone: [
          {
            required: true,
            message: '请输入经办人手机号',
            trigger: 'change'
          }
        ],
        transactorName: [
          {
            required: true,
            message: '请输入经办人姓名',
            trigger: 'change'
          }
        ],
        transactorEmail: [
          { required: true, message: '请输入经办人邮箱地址', trigger: 'blur' },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change']
          }
        ],
        transactorCardZheng: [
          {
            required: true,
            validator: checkTransactorCardZheng,
            trigger: 'change'
          }
        ],
        transactorCardFan: [
          {
            required: true,
            message: '请上传身份证',
            trigger: 'change'
          }
        ]
      },
      ssqProps: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level, value } = node;
          dictionaries
            .getRegionList({
              level: level + 1,
              parentCode: value || 0
            })
            .then(res => {
              const { pdata } = res;
              const list = pdata.map(item => {
                return {
                  value: item.code,
                  label: item.name,
                  leaf: level >= 2
                };
              });
              resolve(list);
            });
        }
      },
      searchBank: dictionaries.bankList,
      ProProp: {
        label: 'bank_Name',
        code: 'bankCode'
      },
      searchProvince: dictionaries.areaList,
      provinceProp: {
        label: 'areaName',
        code: 'areaCode'
      },
      provinceObj: {
        fId: 0
      },
      emptyFlag: 0,
      defaultBank: {
        bank_Name: '',
        bankCode: ''
      },
      defaultProvince: {
        areaName: '',
        areaCode: ''
      },
      defaultCity: {
        areaName: '',
        areaCode: ''
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '长期',
            onClick(picker) {
              const leftValue = picker.$children[0].minDate; // 获取当前左侧选择日期,优先使用选择时的值。
              picker.$emit('pick', [leftValue, '长期']);
            }
          }
        ]
      }
    };
  },
  components: {
    step,
    UploadImgOne,
    dicSelect,
    step1Dt
  },
  computed: {
    cityObj() {
      return { fId: this.ruleForm.openBankProvinceCode };
    },
    isOtherBank() {
      return (
        ['10', '12'].includes(this.ruleForm.fyChannel) &&
        this.selectBankName === 'fyBank'
      );
    },
    tipsDay() {
      return this.ruleForm.fyChannel === '01' ? '1' : '1-2';
    }
  },
  watch: {
    'ruleForm.category': {
      handler(v) {
        const [majorCategory, subCategory, mcc] = v;
        this.$nextTick(() => {
          const businessDesc = this.$refs.cascaderRefByCategory.presentText.split(
            '/'
          )[2];
          this.ruleForm.businessDesc = businessDesc;
          this.ruleForm.majorCategory = majorCategory;
          this.ruleForm.subCategory = subCategory;
          this.ruleForm.mcc = mcc;

          // 不加这俩会导致搜索级联选项后再次展开下拉未在其子级 此时仍然保留了上次选中的父级
          this.$refs.cascaderRefByCategory.$refs.panel.activePath = []; // 清除高亮
          this.$refs.cascaderRefByCategory.$refs.panel.syncActivePath(); // 初始化（只展示一级节点）
        });
      }
    },
    'ruleForm.ssq': {
      handler(v) {
        const [provinceCode, cityCode, areaCode] = v;
        this.$nextTick(() => {
          const [
            provinceName,
            cityName,
            areaName
          ] = this.$refs.cascaderRefByArea.presentText.split('/');
          this.ruleForm.provinceCode = provinceCode;
          this.ruleForm.cityCode = cityCode;
          this.ruleForm.areaCode = areaCode;
          this.ruleForm.provinceName = provinceName;
          this.ruleForm.cityName = cityName;
          this.ruleForm.areaName = areaName;
        });
      }
    }
  },
  methods: {
    ssqChange(v) {
      this.ruleForm.ssq = v;
    },
    //添加受益人信息
    addFyBeneficiaryInfo() {
      if (this.ruleForm.fyBeneficiaryInfoList.length >= 3) {
        this.$message({
          message: '最多添加3组',
          type: 'warning'
        });
        return;
      }
      this.ruleForm.fyBeneficiaryInfoList.push({
        name: '',
        certTp: '0',
        certNo: '',
        validDateStart: '',
        validDateEnd: '',
        mobile: '',
        address: '',
        portraitFilePath: '',
        badgeFilePath: '',
        beneficiaryType: ''
      });
    },
    //添加股东/实控人信息
    addFyShareholderInfo() {
      if (this.ruleForm.fyShareholderInfoList.length >= 4) {
        this.$message({
          message: '最多添加4组',
          type: 'warning'
        });
        return;
      }
      this.ruleForm.fyShareholderInfoList.push({
        name: '',
        certTp: '0',
        certNo: '',
        validDateStart: '',
        validDateEnd: '',
        portraitFilePath: '',
        badgeFilePath: ''
      });
    },
    imgTypeChange(item, refKey) {
      item.portraitFilePath = '';
      item.badgeFilePath = '';
      this.$nextTick(() => {
        this.$refs[refKey].forEach(item => {
          item.picUrl = '';
        });
      });
    },
    delItem(arr, index) {
      if (arr && arr.length > 0 && index >= 0 && index < arr.length) {
        arr.splice(index, 1);
      } else {
        console.warn('索引超出范围或数组为空');
      }
    },
    jumpContract() {
      location.href =
        '//cdn.yxvzb.com/WEB/PDF/web/%E6%AD%A6%E6%B1%89%E4%BC%97%E9%82%A6%E9%93%B6%E8%A1%8CE%E8%B4%A6%E9%80%9A%E7%B3%BB%E7%BB%9F%E5%BC%80%E6%88%B7%E4%B8%89%E6%96%B9%E5%8D%8F%E8%AE%AE-%E4%BC%81%E4%B8%9A%EF%BC%88V1.0%E7%89%88%E6%9C%AC%EF%BC%89.docx';
    },
    saveProId(val) {
      this.ruleForm.openBankName = val.bank_Name;
      this.ruleForm.openBankNode = val.bankCode;
      this.$refs.ruleForm.validateField('openBankName');
      // this.$refs['ruleForm'].$emit('el.form.change');
    },
    saveProvince(val) {
      this.ruleForm.openBankProvinceName = val.areaName;
      this.ruleForm.openBankProvinceCode = val.areaCode;
      this.ruleForm.openBankCityName = '';
      this.ruleForm.openBankCityCode = '';
      this.emptyFlag += 1;
      this.$refs.ruleForm.validateField('openBankCityCode');
      // this.$refs['ruleForm'].$emit('el.form.change');
    },
    saveCity(val) {
      this.ruleForm.openBankCityName = val.areaName;
      this.ruleForm.openBankCityCode = val.areaCode;
      // this.$refs['ruleForm'].$emit('el.form.change');
      this.$refs.ruleForm.validateField('openBankCityCode');
    },
    coverPicDone(v) {
      this.ruleForm.companyBusinessLicense = v;
      this.$refs.ruleForm.validateField('companyBusinessLicense');
    },
    coverPicDone2(v) {
      this.ruleForm.legalPersonCardZheng = v;
      this.$refs.ruleForm.validateField('legalPersonCardZheng');
    },
    coverPicDone3(v) {
      this.ruleForm.legalPersonCardFan = v;
      this.$refs.ruleForm.validateField('legalPersonCardZheng');
    },
    coverPicDone4(v) {
      this.ruleForm.transactorCardZheng = v;
      this.$refs.ruleForm.validateField('transactorCardZheng');
    },
    coverPicDone5(v) {
      this.ruleForm.transactorCardFan = v;
      this.$refs.ruleForm.validateField('transactorCardZheng');
    },
    coverPicDoneByArray(v, item, key, rulesName) {
      item[key] = v;
      this.$refs.ruleForm.validateField(rulesName);
    },
    // 受益人证件
    validatorCardImg(index) {
      return [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (!this.ruleForm.fyBeneficiaryInfoList[index].portraitFilePath) {
              callback(new Error('请上传证件正面'));
            } else if (
              !this.ruleForm.fyBeneficiaryInfoList[index].badgeFilePath
            ) {
              callback(new Error('请上传证件反面'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }
      ];
    },
    // 股东证件
    validatorCardImg2(index) {
      return [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (!this.ruleForm.fyShareholderInfoList[index].portraitFilePath) {
              callback(new Error('请上传证件正面'));
            } else if (
              !this.ruleForm.fyShareholderInfoList[index].badgeFilePath
            ) {
              callback(new Error('请上传证件反面'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }
      ];
    },
    // 营业执照
    validatorCardImg3(index) {
      return [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (!this.ruleForm.fyShareholderInfoList[index].portraitFilePath) {
              callback(new Error('请上传营业执照'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }
      ];
    },
    submitForm(formName) {
      this.SET_BTLOADING(true);
      this.$refs[formName].validate(valid => {
        if (valid) {
          const bankAuthMap = {
            zbBank: this.authStatus.zbAuthStatus,
            fyBank: this.authStatus.fyAuthStatus
          };
          const id =
            bankAuthMap[this.selectBankName] === 0 ? null : this.ruleForm.id;
          const reqFormData = {
            ...this.ruleForm,
            payPassagewayCode: this.selectBankName,
            id
          };
          if (!id) {
            delete reqFormData.id;
          }
          dictionaries.addOpenAccount(reqFormData).then(async res => {
            this.$message({
              message: res.data.message,
              type: 'success'
            });
            // 线下开通后，进入结算中心。线上与全都展示按线上流程处理
            if (this.offlineProject === 2) {
              this.$emit('changeComp', { type: 0, currentCom: 'dashBoard' });
            } else {
              this.$emit('changeComp', { type: 1, currentCom: 'step2' });
            }
            this.SET_BTLOADING(false);
          });
        } else {
          this.SET_BTLOADING(false);
          return false;
        }
      });
    }
  },
  async created() {
    const {
      pdata: { offlineProject }
    } = await dictionaries.isOpenAccount();
    this.offlineProject = offlineProject;
    // 行业类别下拉
    const { pdata } = await dictionaries.getCategoryList();
    this.categoryListOption = pdata;
    dictionaries
      .userOpenDetail({
        payPassagewayCode: this.selectBankName
      })
      .then(res => {
        if (res.data.data.userOpen) {
          this.ruleForm = {
            ...this.ruleForm,
            ...res.data.data.userOpen
          };
          this.defaultBank = {
            bank_Name: this.ruleForm.openBankName,
            bankCode: this.ruleForm.openBankNode
          };
          this.defaultProvince = {
            areaName: this.ruleForm.openBankProvinceName,
            areaCode: Number(this.ruleForm.openBankProvinceCode)
          };
          this.defaultCity = {
            areaName: this.ruleForm.openBankCityName,
            areaCode: Number(this.ruleForm.openBankCityCode)
          };
          // 省市区和行业类别 前端显示用一个数组 后端用了仨字段
          const {
            provinceCode,
            cityCode,
            areaCode,
            majorCategory,
            subCategory,
            mcc
          } = res.data.data.userOpen;
          this.ruleForm.ssq = [...[provinceCode, cityCode, areaCode]];
          this.ruleForm.category = [...[majorCategory, subCategory, mcc]];
          if (
            res.data.data.payFyShareholderInfoList &&
            res.data.data.payFyBeneficiaryInfoList
          ) {
            this.ruleForm.fyBeneficiaryInfoList =
              res.data.data.payFyBeneficiaryInfoList;
            this.ruleForm.fyShareholderInfoList =
              res.data.data.payFyShareholderInfoList;
          }
        }
      });
  }
};
</script>
<style lang="scss">
.banktips {
  background-color: #f4f4f5;
  color: #909399;
  margin-left: 230px;
  padding: 0 10px;
  max-width: 440px;
}
.del__btn {
  position: absolute;
  top: 15px;
  right: 100px;
  z-index: 9;
}
.notes {
  margin-top: 30px;
  height: 46px;
  line-height: 46px;
  color: #bfbfbf;
  font-size: 14px;
  margin-bottom: 46px;
  text-align: left;
}
.flexItem {
  .el-form-item__content {
    display: flex;
    margin-left: 0 !important;
  }
}
</style>
<style lang="scss" scoped>
.ruleForm {
  // width: 1500px;
  // margin: 0 auto;
}
.colorBlock {
  font-size: 20px;
  line-height: 25px;
  display: flex;
  color: #2e2e2f;
  font-weight: bold;
  padding: 5px 0;
}
.colorBlock::before {
  content: '';
  width: 10px;
  height: 25px;
  background: blue;
  margin-right: 5px;
  display: inline-block;
}
.flexBox {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 0px;
}
.elLabel {
  color: #333;
  font-size: 14px;
  font-weight: bold;
}
.redHint {
  color: #ef0707;
  font-style: normal;
  font-size: 12px;
  line-height: 17px;
  font-weight: normal;
  display: inline-block;
  text-align: left;
  width: 98px;
}
.leftLabel {
  width: 50%;
}
.rightLabel {
  width: 50%;
  ::v-deep {
    .el-input {
      width: 250px !important;
    }
  }
}
</style>
